import type { FormatterFactory } from '../types';
import { compilePath } from '../gridCell';

export interface GetValueOptions {
  field?: string;
  source?: 'row' | 'value';
  separator?: string;
}

export const getvalue: FormatterFactory = (options: GetValueOptions = {}) => {
  const fields = String(options.field ?? '')
    .split(',')
    .map((field) => field.trim())
    .filter(Boolean);
  const readers = fields.map(compilePath);
  const separator = options.separator ?? ' ';
  const fromRow = (options.source ?? 'row') === 'row';

  return {
    toText: (value, context) => {
      const source = fromRow ? context : value;
      if (readers.length <= 1) {
        return asText(readers[0]?.(source));
      }
      return readers
        .map((read) => read(source))
        .filter((part) => part != null && part !== '')
        .map(asText)
        .join(separator);
    },
  };
};

function asText(value: any): string {
  return value == null ? '' : String(value);
}
